export default {
    onInactivity() {
        if (this.fetchedData.id !== 'electric-search') {
            return;
        }

        this.openInactivityModal().then(() => {
            const faqSectionElm = document.getElementsByClassName('submodel-offers__faq-section')[0];

            if (!faqSectionElm) {
                return;
            }

            faqSectionElm.scrollIntoView({ behavior: 'smooth' });
        });
    },
    onPromoBannerClick() {
        this.openIncentiveModal();
    },
};
